
import { AdminLogo } from "./admin/AdminLogo";
import { AdminNavigation } from "./admin/AdminNavigation";
import { AdminUserMenu } from "./admin/AdminUserMenu";
import { AdminMobileMenu } from "./admin/AdminMobileMenu";

interface AdminHeaderProps {
  userName: string | null;
  networkStatus: "checking" | "verified" | "failed";
  onNetworkCheck: () => void;
  onNewOrder: () => void;
  onPriceCheck: () => void;
  onEmployeeClockIn: () => void;
  onEmployeeManagement: () => void;
  onViewBackend: () => void;
  onScannerTest: () => void;
  onSwitchToStaff: () => void;
  onSuppliersManagement: () => void;
  onCreditReports: () => void;
  onCostMonitor: () => void;
  onMasterProducts: () => void;
  onAdminSettings?: () => void;
  onArchivedOrders?: () => void;
  onLoginAttempts: () => void;
}

export const AdminHeader = ({
  userName,
  networkStatus,
  onNetworkCheck,
  onNewOrder,
  onPriceCheck,
  onEmployeeClockIn,
  onEmployeeManagement,
  onViewBackend,
  onScannerTest,
  onSwitchToStaff,
  onSuppliersManagement,
  onCreditReports,
  onCostMonitor,
  onMasterProducts,
  onAdminSettings,
  onArchivedOrders,
  onLoginAttempts
}: AdminHeaderProps) => {
  return (
    <header className="bg-white border-b border-gray-200 shadow-sm relative">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          <AdminLogo />
          
          <AdminNavigation
            onNewOrder={onNewOrder}
            onViewBackend={onViewBackend}
            onPriceCheck={onPriceCheck}
            onScannerTest={onScannerTest}
            onEmployeeManagement={onEmployeeManagement}
            onEmployeeClockIn={onEmployeeClockIn}
            onSuppliersManagement={onSuppliersManagement}
            onCreditReports={onCreditReports}
            onCostMonitor={onCostMonitor}
            onMasterProducts={onMasterProducts}
            onArchivedOrders={onArchivedOrders}
            onLoginAttempts={onLoginAttempts}
          />

          <div className="flex items-center space-x-4">
            <AdminUserMenu
              userName={userName}
              networkStatus={networkStatus}
              onNetworkCheck={onNetworkCheck}
              onSwitchToStaff={onSwitchToStaff}
              onAdminSettings={onAdminSettings}
            />

            <AdminMobileMenu
              onNewOrder={onNewOrder}
              onViewBackend={onViewBackend}
              onPriceCheck={onPriceCheck}
              onScannerTest={onScannerTest}
              onEmployeeManagement={onEmployeeManagement}
              onEmployeeClockIn={onEmployeeClockIn}
              onMasterProducts={onMasterProducts}
              onSuppliersManagement={onSuppliersManagement}
              onCreditReports={onCreditReports}
              onCostMonitor={onCostMonitor}
            />
          </div>
        </div>
      </div>
    </header>
  );
};
